/* eslint-disable no-undef */
import $ from "jquery"

/**
 * delcare class
 */
const CareerFilterAjax = () => {
  /**
   * call all function
   */
  const init = () => {
    getDataOnClick()
    getSearchInput()
  }

  /**
   * setup data on click
   */
  const getDataOnClick = () => {
    $(document).on("click", ".js-Filter__Input", function () {
      let selected = $(".js-Filter__Input")

      let id_arr_dep = []
      let id_arr_loc = []
      let id_arr_exp = []

      $.each(selected, function () {
        if ($(this).is(":checked")) {
          let id = $(this).val()
          let type = $(this).data("type")

          if (type === "departements") {
            id_arr_dep.push(id)
          } else if (type === "experience") {
            id_arr_exp.push(id)
          } else if (type === "location") {
            id_arr_loc.push(id)
          }
        }
      })

      getDataByAjax(id_arr_dep, id_arr_loc, id_arr_exp)
    })
  }

  /**
   * get data by ajax
   */
  const getDataByAjax = (id_arr_dep, id_arr_loc, id_arr_exp) => {
    let data = {
      action: parameters.action,
      nonce: parameters.nonce,
      id_arr_dep: id_arr_dep,
      id_arr_loc: id_arr_loc,
      id_arr_exp: id_arr_exp,
    }

    $.ajax({
      type: "POST",
      data: data,
      url: parameters.url_admin_ajax,
      dataType: "json",
    }).done(function (result) {
      let data = result.data
      $("#total-carreers").text(`Showing ${data.total} positions`)
      $("#row-carreers").empty()
      $(".js-SearchBar__Input").val("")
      $("#row-carreers").append(data.template)
    })
  }

  const getSearchInput = () => {
    const call = _debounce((input) => {
      let data = {
        action: parameters.action_search,
        nonce: parameters.nonce,
        input: input,
      }

      $.ajax({
        type: "POST",
        data: data,
        url: parameters.url_admin_ajax,
        dataType: "json",
      }).done(function (result) {
        let data = result.data
        $("#total-carreers").text(`Showing ${data.total} positions`)
        $("#row-carreers").empty()
        $("#row-carreers").append(data.template)
      })
    }, 500)

    $("#form_search_carreer .js-SearchBar__Input").on("input", function (e) {
      e.preventDefault()
      // call($(this).val());

      const val = $(this).val()
      console.error(val)
      const content = $("#row-carreers .mi-CareerArchive__Col")

      content.each(function () {
        $(this).css("display", "none")
        const contentText = $(this)
          .text()
          .split(" ")
          .filter((val_) => val_ !== "")
          .join(" ")
          .replaceAll("\n", " ")
        if (contentText.toLowerCase().search(val.toLowerCase()) !== -1) {
          $(this).css("display", "block")
        }
      })
    })

    $("#form_search_carreer").on("submit", function (e) {
      e.stopPropagation()
      e.preventDefault()

      let input = $("#search_input").val()

      let data = {
        action: parameters.action_search,
        nonce: parameters.nonce,
        input: input,
      }

      $.ajax({
        type: "POST",
        data: data,
        url: parameters.url_admin_ajax,
        dataType: "json",
      }).done(function (result) {
        let data = result.data
        $("#total-carreers").text(`Showing ${data.total} positions`)
        $("#row-carreers").empty()
        $("#row-carreers").append(data.template)
      })
    })
  }

  const _debounce = (cb, delay = 1000) => {
    let timeout

    return (...args) => {
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        cb(...args)
      }, delay)
    }
  }

  /**
   * run all function
   */
  init()
}

/**
 * initialisisasi
 */
try {
  CareerFilterAjax()
} catch (e) {
  console.log(e)
}
